import './PageContainer.css';

const PageContainerBlank = () => {
	return (
		<div id="page-container-blank"></div>
	);
};

export default PageContainerBlank;
